import { QueryClient } from "@tanstack/react-query";
import { Step } from "~/lib/pipeline";
import { Job, Build } from "~/components/build/Show/lib/types";
import { stepJobsQueryOptions } from "~/components/build/Show/lib/queries/stepJobs";

/**
 * Fetch jobs associated with a step that switches behavior based on the progressive build feature flag.
 */
/** @deprecated Use `~/components/build/Show/pages/steps/list/components/TreeNode/fetchBuildStepJobs` instead. */
export function fetchBuildStepJobs<T extends Job>(
  queryClient: QueryClient,
  step: Step,
  build: Build,
): Promise<T[]> {
  if (Features.ProgressiveBuildShow) {
    return queryClient
      .fetchQuery(stepJobsQueryOptions(build, step.uuid))
      .then((jobs) => jobs as T[])
      .catch(() => [] as T[]);
  }
  const jobs = build.jobs.filter((job) => job.stepUuid === step.uuid);
  return Promise.resolve(jobs as T[]);
}
